<template>
    <div class="e_handle_content page_update_supply">
        <div class="topOperation">
            <div class="top-left">
                <ShowNavHead />
            </div>
        </div>
        <div class="main-con">
            <div class="crumbs">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>产品</el-breadcrumb-item>
                <el-breadcrumb-item>灵活用工</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/teamMembers' }">施工队员列表</el-breadcrumb-item>
                <el-breadcrumb-item>{{pageTitle}}</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="e_handle_box">
                <p class="r_edit_title">基础信息</p>
                <div class="e_handle_form" v-loading="formLoading">
                    <div class="dtl_box">
                        <div class="dtl_list">
                            <div class="dtl_left_box">施工队名称:</div>
                            <div class="dtl_right_box">{{basicQuery.strConstrteamName}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">人员编号:</div>
                            <div class="dtl_right_box">{{basicQuery.StrPersonNum}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">人员类别:</div>
                            <div class="dtl_right_box">{{basicQuery.StrDutie}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">是否参与实际施工:</div>
                            <div class="dtl_right_box">{{basicQuery.StrIsActconstr}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">姓名:</div>
                            <div class="dtl_right_box">{{basicQuery.StrPerName}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">身份证号码:</div>
                            <div class="dtl_right_box">{{basicQuery.StrIdcard}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">身份证有效截止期:</div>
                            <div class="dtl_right_box">{{basicQuery.StrIdcDate}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">联系方式:</div>
                            <div class="dtl_right_box">{{basicQuery.StrMobile}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">服务状态:</div>
                            <div class="dtl_right_box">{{basicQuery.StrPerStatus}}</div>
                        </div>
                        <div class="dtl_list" v-if="basicQuery.StrPerStatus == '退出'">
                            <div class="dtl_left_box">退出日期:</div>
                            <div class="dtl_right_box">{{basicQuery.DtexitDate}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">上岗证编号:</div>
                            <div class="dtl_right_box">{{basicQuery.StrjoblicenNum}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">上岗证有效截止期:</div>
                            <div class="dtl_right_box">{{basicQuery.StrjobCertDate}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">上岗证注销次数:</div>
                            <div class="dtl_right_box">{{basicQuery.StrjobCertoffNum}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">电工证编号:</div>
                            <div class="dtl_right_box">{{basicQuery.StrElecertNum}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">电工证类型:</div>
                            <div class="dtl_right_box">{{basicQuery.StrElecertType}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">电工证有效截止期:</div>
                            <div class="dtl_right_box">{{basicQuery.StreffectDate}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">意外险保单号:</div>
                            <div class="dtl_right_box">{{basicQuery.StrAccinsupolinum}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">意外险保单有效截止期:</div>
                            <div class="dtl_right_box">{{basicQuery.StrAccinsupoliDate}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">签入日期:</div>
                            <div class="dtl_right_box">{{basicQuery.DtBringDate}}</div>
                        </div>
                        <div class="dtl_list">
                            <div class="dtl_left_box">备注:</div>
                            <div class="dtl_right_box">{{basicQuery.StrRemark}}</div>
                        </div>
                    </div>
                    <div class="f_upload_box">
                        <p class="r_edit_title" v-if="!isNull(fileSupList01)">1寸照</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList01)">
                            <!-- <div class="f_upload_left">营业执照:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList01" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px;margin-right:10px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item.url)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList02)">意外保险保单</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList02)">
                            <!-- <div class="f_upload_left">法人委托授权书:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList02" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item.url)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList03)">身份证照片</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList03)">
                            <!-- <div class="f_upload_left">工程车照片:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList03" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item.url)">下载</el-button>
                            </div>
                        </div>
                        <p class="r_edit_title" v-if="!isNull(fileSupList04)">电工证照片</p>
                        <div class="f_upload_list" v-if="!isNull(fileSupList04)">
                            <!-- <div class="f_upload_left">仓库照片:</div> -->
                            <div class="demo-image__preview" v-for="(item,index) in fileSupList04" :key="index">
                                <el-image v-if="item.type == 'img'"
                                    style="width: 100px; height: 100px"
                                    :src="tablePath+item.url" 
                                    :preview-src-list="[tablePath+item.url]">
                                </el-image>
                                <p v-else class="dtl_file_txt" :title="item.name">{{item.name}}</p>
                                <el-button type="text" size="small" @click="handleDownload(item.url)">下载</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="e_btns_box">
            <div class="e_btns_content">
                <el-button @click="backHandle">返回</el-button>
                <el-button v-if="isStrExamStatus" type="primary" :loading="btnLoading" @click="identifyHandle">认证</el-button>
            </div>
        </div>
        <!-- 修改认证状态弹框 -->
        <el-dialog title="设置认证状态" :visible.sync="identifyVisible" width="600px" class="res_dialog">
            <el-form :model="identifyQuery" :rules="identifyRules" ref="dtreachForm" class="re_dialog_form" label-width="130px">
                <el-form-item label="认证状态:" prop="StrExamStatus" required>
                    <el-select v-model="identifyQuery.StrExamStatus" placeholder="" size="small">
                        <el-option label="已认证" value="已认证"></el-option>
                        <el-option label="认证失败" value="认证失败"></el-option>
                        <el-option label="未认证" value="未认证"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注:" prop="strRemark">
                    <el-input v-model="identifyQuery.strRemark" type="textarea" size="small" clearable></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    @click="identifyVisible = false"
                    size="small"
                    >取消</el-button>
                <el-button
                    type="primary" class="com_dialog_btn"
                    @click="saveIdentifyHandle"
                    size="small"
                    >确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
import xz from "./../../common";
import moment from 'moment'
export default {
    data() {
        return {
            pageTitle:'施工队员详情',
            identifyRules: {
                StrExamStatus: [
                    { required: true, message: '请选择认证状态', trigger: 'change' }
                ]
            },
            tablePath: this.$store.state.EMP.docPath,
            predialogVisible:false,
            dialogImageUrl:'',//预览图片
            btnLoading:false,
            formLoading:false,
            // 默认头像
            defaultPic: require(("./../../assets/images/psn.png")),
            // 基础信息参数
            basicQuery:{
                strConstrteamName:'',//施工队名称
                GdteamperId:'', //人员id
                StrPersonNum:'', //人员编号
                StrPersonNumOther:'',
                GdteamId:'', //施工队编号
                StrPerName:'', //姓名
                StrPerStatus:'', //服务状态
                StrDutie:'', //人员类别
                StrIsActconstr:'', //是否参与实际施工
                StrIdcard:'', //身份证号码
                StrIdcDate:'', //身份证有效期
                StrMobile:'', //联系方式
                StrjoblicenNum:'', //上岗证编号
                StrjobCertDate:'', //上岗证有效期
                StrjobCertoffNum:'', //上岗证注销次数
                StrElecertNum:'', //电工证编号
                StrElecertType:'', //电工证类型
                StreffectDate:'', //电工证有效期
                StrAccinsupolinum:'', //意外险保单号
                StrAccinsupoliDate:'', //意外险保单有效期
                StrRemark:'', //备注
                DtexitDate:'',//退出时间
                DtBringDate:'', //签入日期
                Strsettlement:'', //是否负责结算
                StrBankCardNum:'', //银行卡号码
                StrBankCardName:'', //银行名称
                StrresponNum:'', //第三方责任险保单号（平台投保
                Strrespondeadline:'' //第三方责任险保单有效截止日期
            },
            // 营业执照
            fileSupList01:[],
            // 法人委托授权书
            fileSupList02:[],
            fileSupList03:[],
            fileSupList04:[],
            fileSupList05:[],
            fileSupList06:[],
            activeName:'',
            identifyVisible:false,
            // 认证参数
            identifyQuery:{
                GdupId:'',//标识
                StrExamStatus:'',//已认证   认证失败  未认证
                strTableId:'JB_busi_ConstrPerson',//JB_busi_ConstrTeam 施工队 JB_busi_ConstrPerson施工队员
                strRemark:'' //备注
            },
            isStrExamStatus:false//是否已认证
        }
    },
    created() {
        // console.log('yy',this.$route.params)
        // this.processQuery.Jobid = this.$route.params.Jobid
        if(!this.isNull(this.$route.query.id)){
            this.basicQuery.GdteamperId = this.$route.query.id
            // 获取详情
            this.getDetailData(this.basicQuery.GdteamperId)
        }
    },
    methods:{
        // 退出
        identifyHandle(){
          this.identifyVisible = true
          this.identifyQuery.GdupId = this.basicQuery.GdteamperId
          this.identifyQuery.DtexitDate = ''
          this.identifyQuery.strRemark = ''
        },
        // 保存认证
        saveIdentifyHandle(){
          this.$refs['dtreachForm'].validate((valid) => {
            if (valid) {
                xz.saveConstrExamStatus(this.identifyQuery).then(res => {
                    if (res.status == 'ok') {
                        this.$message({ type: 'success', message: '操作成功' })
                        this.getDetailData(this.basicQuery.GdteamperId)
                        this.identifyVisible = false
                    }else{
                        this.$message({ type: 'error', message: '操作失败，请稍后再试' })
                    }
                })
            }
          })
        },
        // 判断文件类型,图片预览，文件下载
        updataIf(e) {
            if (e.fileName) {
                let type1 = e.fileName.substring(e.fileName.length-4,e.fileName.length)
                if (type1.indexOf('png')>-1||type1.indexOf('PNG')>-1||type1.indexOf('JPG')>-1||type1.indexOf('JPEG')>-1||type1.indexOf('jpg')>-1||type1.indexOf('jpeg')>-1||type1 == 'webp') {
                    return false
                } else {
                    return true
                }
            } else {
                let type2 = e.name.substring(e.name.length-4,e.name.length)
                if (type2.indexOf('png')>-1||type2.indexOf('PNG')>-1||type2.indexOf('JPG')>-1||type2.indexOf('JPEG')>-1||type2.indexOf('jpg')>-1||type2.indexOf('jpeg')>-1||type2 == 'webp') {
                    return false
                } else {
                    return true
                }
            }
        },
        // 获取详情
        getDetailData(id){
            let that = this
            this.fileSupList01 = []
            this.fileSupList02 = []
            this.fileSupList03 = []
            this.fileSupList04 = []
            xz.getConstrTeamPerDetail({GdteamperId:id}).then(res => {
                // console.log('www', res)
                let str1 = res.msg.r.StrPersonNum
                if (res.status == 'ok') {
                    if(res.msg.r.StrExamStatus == '已认证'){
                        this.isStrExamStatus = false
                    }else{
                        this.isStrExamStatus = true
                    }
                    this.basicQuery = {
                        strConstrteamName:res.msg.StrConstrteamName,
                        GdteamperId:res.msg.r.GdteamperId, //人员id
                        StrPersonNum:res.msg.r.StrPersonNum, //人员编号
                        StrPersonNumOther:str1.substring(str1.length-2,str1.length),
                        GdteamId:res.msg.r.GdteamId, //施工队编号
                        StrPerName:res.msg.r.StrPerName, //姓名
                        StrPerStatus:res.msg.r.StrPerStatus, //服务状态
                        StrDutie:res.msg.r.StrDutie, //人员类别
                        StrIsActconstr:res.msg.r.StrIsActconstr, //是否参与实际施工
                        StrIdcard:res.msg.r.StrIdcard, //身份证号码
                        StrIdcDate:res.msg.r.StrIdcDate, //身份证有效期
                        StrMobile:res.msg.r.StrMobile, //联系方式
                        StrjoblicenNum:res.msg.r.StrjoblicenNum, //上岗证编号
                        StrjobCertDate:res.msg.r.StrjobCertDate, //上岗证有效期
                        StrjobCertoffNum:res.msg.r.StrjobCertoffNum, //上岗证注销次数
                        StrElecertNum:res.msg.r.StrElecertNum, //电工证编号
                        StrElecertType:res.msg.r.StrElecertType, //电工证类型
                        StreffectDate:res.msg.r.StreffectDate, //电工证有效期
                        StrAccinsupolinum:res.msg.r.StrAccinsupolinum, //意外险保单号
                        StrAccinsupoliDate:res.msg.r.StrAccinsupoliDate, //意外险保单有效期
                        StrRemark:res.msg.r.StrRemark, //备注
                        DtexitDate:res.msg.r.DtexitDate, //退出日期
                        DtBringDate:res.msg.r.DtBringDate, //签入日期
                        Strsettlement:res.msg.r.Strsettlement, //是否负责结算
                        StrBankCardNum:res.msg.r.StrBankCardNum, //银行卡号码
                        StrBankCardName:res.msg.r.StrBankCardName, //银行名称
                        StrresponNum:res.msg.r.StrresponNum, //第三方责任险保单号（平台投保
                        Strrespondeadline:res.msg.r.Strrespondeadline //第三方责任险保单有效截止日期
                    }
                    if(!this.isNull(res.msg.StrConstrteamName)){
                        let resTxt = res.msg.StrConstrteamName.split(res.msg.StrConstrteamCode)
                        this.basicQuery.StrRegisShortCompany = resTxt[1]
                    }
                    if(!this.isNull(res.msgfile1)){
                        for (let i = 0; i < res.msgfile1.length; i++) {
                            let element1 = res.msgfile1[i];
                            let type1 = element1.StrFile.substring(element1.StrFile.length-4,element1.StrFile.length)
                            this.fileSupList01.push({
                                url:element1.StrFileUrl,
                                name:element1.StrFile,
                                type: (type1.indexOf('png')>-1||type1.indexOf('PNG')>-1||type1.indexOf('JPG')>-1||type1.indexOf('JPEG')>-1||type1.indexOf('jpg')>-1||type1.indexOf('jpeg')>-1||type1 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile2)){
                        for (let j = 0; j < res.msgfile2.length; j++) {
                            let element2 = res.msgfile2[j];
                            let type2 = element2.StrFile.substring(element2.StrFile.length-4,element2.StrFile.length)
                            this.fileSupList02.push({
                                url:element2.StrFileUrl,
                                name:element2.StrFile,
                                type: (type2.indexOf('png')>-1||type2.indexOf('PNG')>-1||type2.indexOf('JPG')>-1||type2.indexOf('JPEG')>-1||type2.indexOf('jpg')>-1||type2.indexOf('jpeg')>-1||type2 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile3)){
                        for (let k = 0; k < res.msgfile3.length; k++) {
                            let element3 = res.msgfile3[k];
                            let type3 = element3.StrFile.substring(element3.StrFile.length-4,element3.StrFile.length)
                            this.fileSupList03.push({
                                url:element3.StrFileUrl,
                                name:element3.StrFile,
                                type: (type3.indexOf('png')>-1||type3.indexOf('PNG')>-1||type3.indexOf('JPG')>-1||type3.indexOf('JPEG')>-1||type3.indexOf('jpg')>-1||type3.indexOf('jpeg')>-1||type3 == 'webp')?'img':'file'
                            })
                        }
                    }
                    if(!this.isNull(res.msgfile4)){
                        for (let l = 0; l < res.msgfile4.length; l++) {
                            let element4 = res.msgfile4[l];
                            let type4 = element4.StrFile.substring(element4.StrFile.length-4,element4.StrFile.length)
                            this.fileSupList04.push({
                                url:element4.StrFileUrl,
                                name:element4.StrFile,
                                type: (type4.indexOf('png')>-1||type4.indexOf('PNG')>-1||type4.indexOf('JPG')>-1||type4.indexOf('JPEG')>-1||type4.indexOf('jpg')>-1||type4.indexOf('jpeg')>-1||type4 == 'webp')?'img':'file'
                            })
                        }
                    }
                }else{
                    this.$message({ type: 'error', message: res.msg })
                }
            })
        },
        // 下载附件
        handleDownload(url) {
            // console.log(url);
            let d = url.replace("\"", "").replace("\"", "")
            var path = this.tablePath + d
            const aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
        },
        // 返回
        backHandle(){
            this.$router.push({
                path: '/teamMembers'
            })
            // this.$router.go(-1) // 后退+刷新
        },
        //判断是否为空(包含0)
        isNull(o) {
            return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == 'NaN' || o == ('1900-01-01') || o == '1900-01-01T00:00:00';
        }
    }
}
</script>

<style>
.e_handle_content .el-form--inline .el-form-item__content{
    vertical-align: middle;
}
.e_handle_content .el-form-item__content{
    width: 335px;
}
.e_handle_content .e_half_line01 .el-form-item__content{
    width: 535px;
}
.e_handle_content .f_all_width01 .el-form-item__content{
    width: calc(100% - 135px);
}
.f_all_width .el-form-item__content{
    width: calc(100% - 135px);
}
.e_handle_content .el-form-item{
    margin-bottom: 16px;
    margin-right: 0;
}
.com_upload_btn .el-icon-plus:before{
    font-size: 28px;
    color: #8c939d;
}
/* .page_update_supply .el-upload-list__item .el-icon-close{
    display: block;
} */
</style>
<style scoped>
.dtl_file_txt{
    margin-right:10px;
    width:100px;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.demo-image__preview{
    display: flex;
    align-items: center;
    margin-right: 30px;
    margin-bottom: 10px;
}
.dtl_list{
    display: flex;
    width: 50%;
    margin-bottom: 12px;
}
.dtl_right_box{
    color:#000;
    flex: 1;
}
.dtl_left_box{
    width: 145px;
    text-align: right;
    color:#999;
    margin-right: 4px;
}
.dtl_box{
    display: flex;
    flex-wrap: wrap;
    padding: 10px 20px;
    box-sizing: border-box;
}
.c_form_box{
    display: flex;
    box-sizing: border-box;
}
.page_update_supply{
    position: relative;
}
.page_update_supply .main-con{
    padding: 0px 15px 80px;
}
.f_date_box{
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}
.f_date_box .f_left{
    text-align: right;
    width: 110px;
    font-size: 14px;
    margin-right: 4px;
    color: #606266;
}
.f_date_box .f_left.f_left01{
    width: 55px;
}
.f_date_box .f_left .note_icon{
    color:#F56C6C;
}
.com_upload_btn{
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    cursor: pointer;
    line-height: 146px;
    vertical-align: top;
}
.r_edit_title .note_icon{
    color:#F56C6C;
    margin-left: 4px;
}
.f_upload_box{
    width: 100%;
}
.r_edit_title{
    width: 100%;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 10px;
    font-weight: bold;
    padding-left: 20px;
    border-bottom: 1px dashed #ddd;
    box-sizing: border-box;
    color: #333;
}
.u_txt{
    color:#999;
    font-weight: bold;
    font-size: 13px;
    margin-bottom: 10px;
}
.f_upload_list{
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 20px;
}
.f_upload_left{
    width: 130px;
    text-align: right;
    vertical-align: middle;
    font-size: 14px;
    color: #606266;
    /* line-height: 40px; */
    padding: 0 12px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.face_line_box{
  display:flex;
  flex-wrap: wrap;
  font-size: 14px;
  margin-left: 10px;
}
.face_line_box .txts01{
  margin-right: 3px;
}
.face_line_box .txts02{
  margin-left: 3px;
}
.r_flex{
    display: flex;
    align-items: center;
}
.e_bottom_box{
    width: 100%;
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
.e_bottom_box p{
    margin-right: 10px;
}
.e_handle_form{
    width: 100%;
    margin: 0 auto;
    flex-wrap: wrap;
}
.e_half_line{
    width: 549px;
}
.e_half_line01{
    width: 652px;
}
.e_handle_content .el-input,.e_handle_content .el-cascader,.e_handle_content .el-select{
    width: 330px;
}
.e_form_box{
    margin-top: 10px;
}
.e_btns_content{
    width: 160px;
    margin-left: calc(50% - 160px);
}
.e_btns_box{
    width: 100%;
    display: flex;
    /* justify-content: center; */
    position: fixed;
    bottom: 0;
    background: #fff;
    z-index: 100;
    box-sizing: border-box;
    padding: 10px 0;
}
.f_all_width{
  width: 100%;
  align-items: center;
}
.e_line01{
    display: flex;
    align-items: center;
}
.e_handle_box .txt01{
    font-size: 13px;
    color:#19bd92;
    cursor: pointer;
    margin-left: 5px;
}
.e_handle_form{
    display: flex;
    /* text-align: center; */
}
.e_handle_box{
    width: 100%;
    padding: 10px 0;
    background-color: #fff;
    box-sizing: border-box;
}
.e_handle_box .el-form-item__label{
    padding: 0 5px 0 0;
}
.e_title{
    width: 100%;
    text-align: center;
    line-height: 25px;
    font-size: 16px;
    color: #333333;
}
</style>